<template>
  <div id = "footer">© 2019 siruQ</div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
#footer{
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: center; /* 横方向中央揃え */
  /*right: 0;*/
  /*bottom: 0;*/
  /*left: 0;*/
  width: 100%;
  height: 30px;
  border-top: 1px solid rgba(0,0,0,.15);
  background: #fff;
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue